export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function registerStickyEvent(el, settings = {}) {
    new IntersectionObserver(
        ([e]) => {
            e.target.classList.toggle('stuck', e.intersectionRatio < 1);
        },
        {
            threshold: [1],
            ...settings,
        }
    ).observe(el);
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const ErrorMsg = {
    template: `<div class="font-bold text-white py-2 px-3 bg-danger" style="border-radius: 0.375rem"><slot /></div>`,
};

export const ValidationMsg = {
    props: ['name'],
    inject: ['$validator'],
    components: { ErrorMsg },
    template: `<error-msg v-if="errors.has(name)">{{ errors.first(name) }}</error-msg>`,
};

export function checkPersonalId(pid) {
    pid = (pid || '').toString();
    pid = pid.replace('/', '');

    let result = {
        valid: false,
        gender: null,
        dob: null,
    };

    try {
        if (pid.length < 9 || pid.length > 10) {
            result.valid = false;
            return result;
        }

        let year = pid.substring(0, 2);
        let month = pid.substring(2, 4);
        let day = pid.substring(4, 6);

        let daysInMonth = function (month, year) {
            return new Date(year, month, 0).getDate();
        };

        if (pid.length == 9) {
            if (year > 53) {
                year = parseInt(year) + 1900;
            } else {
                year = parseInt(year) + 1900;
            }

            if (month > 50) {
                month = parseInt(month) - 50;
                result.gender = 'female';
            } else {
                result.gender = 'male';
            }

            if (month > 20) {
                month = month - 20;
            }

            if (month < 1 || month > 12) {
                return false;
            } else {
                let days = daysInMonth(month, year);
                if (day < 1 || day > days) {
                    result.valid = false;
                    return result;
                }
            }
        }

        if (pid.length == 10) {
            let modulo = pid % 11;
            if (modulo != '0') {
                if (modulo != '10' || modulo != '1') {
                    result.valid = false;
                    return result;
                }
            }

            if (day > 31) {
                day = parseInt(day) - 50;
                if (day < 1 || day > 31) {
                    result.valid = false;
                    return result;
                }
            }

            if (year > 53) {
                year = parseInt(year) + 1900;
            } else {
                year = parseInt(year) + 2000;
            }

            if (month > 50) {
                result.gender = 'female';

                if (month > 70) {
                    month = parseInt(month) - 70;
                } else {
                    month = parseInt(month) - 50;
                }

                if (month < 1 || month > 12) {
                    return false;
                } else {
                    let days = daysInMonth(month, year);
                    if (day < 1 || day > days) {
                        result.valid = false;
                        return result;
                    }
                }
            } else {
                result.gender = 'male';

                if (month < 1 || month > 12) {
                    if (month > 20) {
                        month = month - 20;
                    }

                    if (month < 1 || month > 12) {
                        result.valid = false;
                        return result;
                    }
                } else {
                    let days = daysInMonth(month, year);

                    if (day < 1 || day > days) {
                        result.valid = false;
                        return result;
                    }
                }
            }
        }

        result.dob = new Date(year, month - 1, day);
        result.valid = true;
    } catch (err) {
        //
    }

    return result;
}

export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
}

export function jsonCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export async function printAsync(urlProvider) {
    let win = window.open();
    win.document.write(
        `<div style="display: flex; align-items: center; justify-content: center; position: fixed; top: 0; left: 0; width: 100%; height: 100%; font-size: 30px; font-family: Open Sans, Segoe UI, Tahoma">Načítám...</div>`
    );
    win.document.close();
    try {
        let url = await urlProvider();
        if (!url) {
            throw 'No URL provided';
        }
        win.location = url;
        win.print(); // Probably it's not going to work when location is changed :-(
    } catch (e) {
        win.close();
        throw e;
    }
}

export function fieldComponentName(field) {
    switch (field.type) {
        case 'checkbox':
            return 'checkbox-field';

        case 'checkboxes':
            return 'checkboxes-field';

        case 'checkboxes-inline':
            return 'checkboxes-inline-field';

        case 'select':
            return 'select-field';

        case 'radios':
            return 'radios-field';

        case 'radios-inline':
            return 'radios-inline-field';

        case 'textarea':
            return 'textarea-field';

        case 'image':
            return 'image-field';

        case 'video':
            return 'video-field';

        case 'signArea':
            return 'sign-area-field';

        case 'staticForm':
            return 'html-field';

        case 'html':
            return 'html-field';

        case 'help':
            return 'help-field';

        case 'spacer':
            return 'spacer-field';

        case 'endOfPage':
            return 'end-of-page-field';

        case 'medicaments':
            return 'medicaments-field';

        case 'allergies':
            return 'allergies-field';

        default:
            return 'base-field';
    }
}

export async function signForm(vm, form, idLoggedUser, extraCheck) {
    if (!vm.isIpad()) {
        vm.$vs.notify({
            title: vm.$t('warning'),
            text: vm.$t('locations.signOnlyIpad'),
            color: 'warning',
        });
        return false;
    }

    if (form.idFileSigned) {
        vm.$vs.notify({
            title: vm.$t('warning'),
            text: vm.$t('locations.alreadySigned'),
            color: 'warning',
        });
        return false;
    }

    let definition = JSON.parse(form.definitionV2);
    if (!definition.some((i) => i.key === 'signArea')) {
        vm.$vs.notify({
            title: vm.$t('warning'),
            text: vm.$t('locations.noSignField'),
            color: 'warning',
        });
        return false;
    }

    if (extraCheck) {
        let result = await extraCheck();
        if (result !== true) {
            return false;
        }
    }

    if (form.signatureLoginToken && form.idForm && idLoggedUser) {
        let url = `iOSApp://cz.xdent.xdentSign?token=${form.signatureLoginToken}&idUser=${idLoggedUser}&idForm=${form.idForm}`;
        window.location.href = url;
    } else {
        vm.$vs.notify({
            title: vm.$t('error'),
            text: vm.$t('locations.signError'),
            color: 'danger',
        });
    }
}
